var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesigner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 469.34 469.34",
    style: {
      enableBackground: "new 0 0 469.34 469.34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0EAF9"
    },
    d: "M42.667,0.003h383.996c23.564,0,42.667,19.103,42.667,42.667v341.336 c0,23.564-19.103,42.667-42.667,42.667H42.667C19.103,426.673,0,407.57,0,384.006V42.67C0,19.106,19.103,0.003,42.667,0.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1D5F3"
    },
    d: "M21.333,85.34h426.664c11.782,0,21.333,9.551,21.333,21.333v0.001 c0,11.782-9.551,21.333-21.333,21.333H21.333C9.551,128.007,0,118.456,0,106.674v-0.001C0,94.891,9.551,85.34,21.333,85.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5628B4"
    },
    d: "M42.667,0.003h384c23.564,0,42.667,19.103,42.667,42.667c0,0,0,0,0,0v64l0,0H0l0,0v-64 C0,19.106,19.103,0.003,42.667,0.003L42.667,0.003L42.667,0.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F48BF"
    },
    d: "M42.667,0.003h384.004c11.782,0,21.333,9.551,21.333,21.333v0.001 c0,11.782-9.551,21.333-21.333,21.333H42.667c-11.782,0-21.333-9.551-21.333-21.333v-0.001C21.334,9.554,30.885,0.003,42.667,0.003z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421198"
    },
    d: "M32.001,85.34h405.336c5.891,0,10.667,4.776,10.667,10.667v0c0,5.891-4.776,10.667-10.667,10.667 H32.001c-5.891,0-10.667-4.776-10.667-10.667v0C21.334,90.116,26.11,85.34,32.001,85.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9C9EF"
    },
    d: "M458.667,149.337c-5.891,0-10.667,4.775-10.667,10.666c0,0,0,0,0,0.001v224 c0,11.782-9.551,21.333-21.333,21.333H309.334c-5.891,0-10.667,4.776-10.667,10.667c0,5.891,4.776,10.667,10.667,10.667h117.333 c23.564,0,42.666-19.103,42.667-42.667v-224C469.334,154.112,464.558,149.337,458.667,149.337 C458.667,149.337,458.667,149.337,458.667,149.337L458.667,149.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFD2F2"
    },
    d: "M10.667,192L10.667,192c5.891,0,10.667,4.776,10.667,10.667v170.666 c0,5.891-4.776,10.667-10.667,10.667l0,0C4.776,384,0,379.224,0,373.333V202.667C0,196.776,4.776,192,10.667,192z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7B236"
    },
    cx: 53.337,
    cy: 53.34,
    r: 10.667
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B39DDD"
    },
    cx: 95.997,
    cy: 53.34,
    r: 10.667
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D80E70"
    },
    cx: 138.667,
    cy: 53.34,
    r: 10.667
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B39DDD"
    },
    d: "M405.334,298.67H192c-11.782,0-21.333-9.551-21.333-21.333V170.673 c0-11.782,9.551-21.333,21.333-21.333h213.334c11.782,0,21.333,9.551,21.333,21.333v106.664 C426.667,289.119,417.116,298.67,405.334,298.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B39DDD"
    },
    d: "M106.664,234.67H64c-11.782,0-21.333-9.551-21.333-21.333v-42.664 c0-11.782,9.551-21.333,21.333-21.333h42.664c11.782,0,21.333,9.551,21.333,21.333v42.664 C127.997,225.119,118.446,234.67,106.664,234.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B39DDD"
    },
    d: "M106.664,384H64c-11.782,0-21.333-9.551-21.333-21.333v-42.664c0-11.782,9.551-21.333,21.333-21.333 h42.664c11.782,0,21.333,9.551,21.333,21.333v42.664C127.997,374.449,118.446,384,106.664,384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B39DDD"
    },
    d: "M181.334,320h63.996c5.891,0,10.667,4.776,10.667,10.667l0,0c0,5.891-4.776,10.667-10.667,10.667 h-63.996c-5.891,0-10.667-4.776-10.667-10.667l0,0C170.667,324.776,175.443,320,181.334,320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B39DDD"
    },
    d: "M394.664,320h21.333c5.891,0,10.667,4.776,10.667,10.667l0,0c0,5.891-4.776,10.667-10.667,10.667 h-21.333c-5.891,0-10.667-4.776-10.667-10.667l0,0C383.997,324.776,388.773,320,394.664,320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B39DDD"
    },
    d: "M288.004,320H352c5.891,0,10.667,4.776,10.667,10.667l0,0c0,5.891-4.776,10.667-10.667,10.667 h-63.996c-5.891,0-10.667-4.776-10.667-10.667l0,0C277.337,324.776,282.113,320,288.004,320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B39DDD"
    },
    d: "M181.334,362.67h85.336c5.891,0,10.667,4.776,10.667,10.667l0,0c0,5.891-4.776,10.667-10.667,10.667 h-85.336c-5.891,0-10.667-4.776-10.667-10.667l0,0C170.667,367.446,175.443,362.67,181.334,362.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B39DDD"
    },
    d: "M309.334,362.67h21.333c5.891,0,10.667,4.776,10.667,10.667l0,0c0,5.891-4.776,10.667-10.667,10.667 h-21.333c-5.891,0-10.667-4.776-10.667-10.667l0,0C298.667,367.446,303.443,362.67,309.334,362.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B39DDD"
    },
    d: "M117.33,277.34H53.334c-5.891,0-10.667-4.776-10.667-10.667l0,0c0-5.891,4.776-10.667,10.667-10.667 h63.996c5.891,0,10.667,4.776,10.667,10.667l0,0C127.997,272.564,123.221,277.34,117.33,277.34z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B236"
    },
    d: "M234.667,320.003h-21.331c-58.91,0-106.667,47.756-106.667,106.667c0,0.001,0,0.001,0,0.002v0.565 c0.076,11.653-10.209,20.767-21.862,20.767h-10.14c-5.891,0-10.667,4.776-10.667,10.667c0,5.891,4.776,10.667,10.667,10.667l0,0 h74.667C208.244,469.337,256,421.58,256,362.67v-42.667H234.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58B04"
    },
    d: "M256,362.67v-42.667h-21.333c0,58.91-47.756,106.667-106.667,106.667H106.67v0.566 c0.076,11.652-10.21,20.767-21.862,20.767H74.667c-5.891,0-10.667,4.776-10.667,10.667c0,5.891,4.776,10.667,10.667,10.667h74.667 C208.244,469.336,256,421.58,256,362.67L256,362.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80E70"
    },
    d: "M462.184,113.82c-6.537-6.537-16.207-8.82-24.977-5.896h0 c-75.189,26.567-137.135,81.272-172.798,152.597L256,277.337v42.667h42.667l16.816-8.408 c71.325-35.663,126.03-97.61,152.597-172.798v0C471.004,130.026,468.721,120.357,462.184,113.82L462.184,113.82z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 431.8294 605.5635)",
    style: {
      fill: "#E976AF"
    },
    cx: 341.331,
    cy: 213.347,
    rx: 21.333,
    ry: 56.757
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A60068"
    },
    d: "M437.206,107.923c-3.693,1.305-7.198,2.986-10.826,4.424C423.602,207.998,351.052,287.119,256,298.16 v21.844h42.667l16.816-8.409c71.325-35.663,126.03-97.61,152.598-172.798c4.262-12.789-2.651-26.612-15.44-30.874 C447.631,106.253,442.216,106.253,437.206,107.923L437.206,107.923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5628B4"
    },
    d: "M234.667,320.003L256,341.337l42.667-21.334L256,277.337L234.667,320.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#420F9B"
    },
    d: "M246.199,331.535l9.801,9.801l42.667-21.333l-20.468-20.468c-8.837-8.837-23.163-8.837-32,0 c-1.72,1.72-3.151,3.705-4.239,5.881v0C237.605,314.128,239.312,324.649,246.199,331.535L246.199,331.535z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 10.0251 751.4755)",
    style: {
      fill: "#FBDA9E"
    },
    cx: 160.648,
    cy: 373.661,
    rx: 16.617,
    ry: 42.44
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesigner);
export default __webpack_public_path__ + "static/media/designer.771c49885b9c03c266ff020408723b5e.svg";
export { ForwardRef as ReactComponent };